import { render } from "./GenericError.vue?vue&type=template&id=3256077e&scoped=true&lang=pug"
import script from "./GenericError.vue?vue&type=script&lang=ts"
export * from "./GenericError.vue?vue&type=script&lang=ts"

import "./GenericError.vue?vue&type=style&index=0&id=3256077e&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3256077e"

export default script